<template>
  <!-- 忘记密码 -->
  <div class="sign-box sign-forgot">
    <div class="rounded box-shadow bg-white p-4 w-100 translate">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="h4 font-weight-bold">Forgot password</h4>
        <a href="#login-box" data-login="close"
          ><i class="icon-style icon-xs style-close"></i
        ></a>
      </div>
      <div class="pt-4">
        <p class="small">
          Enter the email associated with your account. We will send you an
          email to reset your password.
        </p>
        <my-input
          v-model="email"
          placeholder="Email address"
          :err-msg="errMsg"
        ></my-input>
        <div class="py-2">
          <a
            class="btn btn-primary d-block w-100"
            href="javascript:void(0)"
            @click="forgetPassword"
            >Reset Password</a
          >
        </div>
        <div class="py-2">
          <a
            id="forgot2sign-in"
            href="#login-box"
            data-login=".sign-in"
            class="btn btn-outline-secondary d-block"
            >Back</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */

import MyInput from "../../form/MyInput";
import swal from "sweetalert";
import request from "../../../utils/Request";
import Validators from "../../../utils/Validators";
export default {
  name: "ForgetPassword",
  components: { MyInput },
  data() {
    return {
      email: "",
      errMsg: "",
      isLoading: false
    };
  },
  methods: {
    forgetPassword() {
      this.errMsg = "";
      if (!this.email) {
        this.errMsg = "Email cannot be empty.";
        return;
      }
      if (!Validators.email(this.email)) {
        this.errMsg = "Incorrect email format.";
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      request({
        baseURL: process.env.VUE_APP_USER_API_URL,
        url: "/v2/auth/forget-password",
        method: "post",
        data: {
          email: this.email
        }
      })
        .then(response => {
          if (response.code !== 200) {
            this.errMsg = response.msg;
          } else {
            this.email = "";
            swal("Email has been sent.");
            $("#forgot2sign-in").click();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
